import { THEME_NAME, THEME_MODE } from 'foundations-theming-base/symbol';
import { THEME_DATA_TAG } from './getLocalThemeSettings';
export function getThemeMetadata(theme) {
  return THEME_NAME in theme && THEME_MODE in theme ? theme : undefined;
}
export const isCanvasTheme = themeObject => {
  var _getThemeMetadata;
  return ((_getThemeMetadata = getThemeMetadata(themeObject)) === null || _getThemeMetadata === void 0 ? void 0 : _getThemeMetadata[THEME_NAME]) === 'canvas';
};
export const isTrellisTheme = themeObject => {
  var _getThemeMetadata2;
  return ((_getThemeMetadata2 = getThemeMetadata(themeObject)) === null || _getThemeMetadata2 === void 0 ? void 0 : _getThemeMetadata2[THEME_NAME]) === 'trellis';
};
export const isLightTheme = themeObject => {
  var _getThemeMetadata3;
  return ((_getThemeMetadata3 = getThemeMetadata(themeObject)) === null || _getThemeMetadata3 === void 0 ? void 0 : _getThemeMetadata3[THEME_MODE]) === 'light';
};
export const isDarkTheme = themeObject => {
  var _getThemeMetadata4;
  return ((_getThemeMetadata4 = getThemeMetadata(themeObject)) === null || _getThemeMetadata4 === void 0 ? void 0 : _getThemeMetadata4[THEME_MODE]) === 'dark';
};
export const hasThemeDataAttribute = () => {
  return document.documentElement.dataset[THEME_DATA_TAG] !== undefined;
};